import { openBlock as t, createElementBlock as l, createStaticVNode as a } from "vue";
const h = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, p = /* @__PURE__ */ a('<g clip-path="url(#a)"><path fill="#FFDA44" d="M20.943 20A11.95 11.95 0 0 0 24 12c0-3.074-1.156-5.877-3.057-8L12 3.13 3.057 4A11.95 11.95 0 0 0 0 12c0 3.074 1.156 5.877 3.057 8l8.943.87z"></path><path fill="#000" d="M3.057 4h17.886A11.97 11.97 0 0 0 12 0a11.97 11.97 0 0 0-8.943 4"></path><path fill="#D80027" d="m0 12 12 1.044 12-1.043c0-1.403-.241-2.75-.684-4H.684A12 12 0 0 0 0 12"></path><path fill="#000" d="M.684 16h22.632A12 12 0 0 0 24 12H0c0 1.402.241 2.748.684 4"></path><path fill="#D80027" d="M20.944 20H3.057c2.197 2.454 5.39 4 8.943 4s6.746-1.546 8.944-4"></path><path fill="#F0F0F0" d="M16.004 12a4.004 4.004 0 1 1-8.008.001 4.004 4.004 0 0 1 8.008 0"></path><path fill="#000" d="M13.467 12.204 12 11.568s.343-1.14.361-1.217a.78.78 0 0 0-.209-.73l.37-.37a1.3 1.3 0 0 0-1.845 0l.369.37a.78.78 0 0 0-.196.78l-.555.555h1.01s-.418.627-.646 1.142a1.053 1.053 0 0 0 .53 1.377l.304.135.507.476v.522l-.522.522h1.044v-1.044l.476-.476h.985l.014-.03a1.044 1.044 0 0 0-.53-1.376"></path></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h24v24H0z"></path></clipPath></defs>', 2), e = [
  p
];
function c(i, d) {
  return t(), l("svg", h, [...e]);
}
const f = { render: c };
export {
  f as default,
  c as render
};
